import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/services/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent {
  private _title = '';
  public get title() {
    this._title = this.translate.instant('SHARED.Loading');
    return this._title;
  }

  private _isVisible = false;
  public get isVisible(): boolean {
    this._isVisible = this.loadingService.isVisible();
    return this._isVisible;
  }

  constructor(private loadingService: LoadingService, private translate: TranslateService) {
     this._title = this.translate.instant('SHARED.Loading');
     this._isVisible = this.loadingService.isVisible();
   }
}
